// 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Box from '@mui/material/Box';
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetAllRegionsData } from '../../Redux/Actions/Regions_Action';
// import Row from 'react-bootstrap/esm/Row';
// import AddIcon from '@mui/icons-material/Add';
// import { Add_Area_Action } from '../../Redux/Actions/AreaActions';
// import { Notify } from '../../Utility/Notify';
// import { Col } from 'react-bootstrap';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { Link } from 'react-router-dom';
// import { CircularProgress, useTheme } from '@mui/material';

// export const AddArea = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const dispatch = useDispatch();
//   const [Areaname, setAreaname] = useState('');
//   const [Region, setRegion] = useState('');
//   const [loading, setloading] = useState(true);
//   const [addLoading, setaddLoading] = useState(false);

//   const Areanamechange = (e) => {
//     setAreaname(e.target.value);
//   };

//   const handleChange = (e) => {
//     setRegion(e.target.value);
//   };

//   // ==================================================
//   // get all regions
//   useEffect(() => {
//     const run = async () => {
//       await dispatch(GetAllRegionsData());
//     };
//     run();
//   }, [dispatch]);

//   const res_All_Regions = useSelector((state) => state.AllRegions.Region);

//   let res_get_AllRegions_array = Array.isArray(res_All_Regions?.data) ? res_All_Regions.data : [];

//   // ============================================================================

//   const onsubmitadd = async (e) => {
//     e.preventDefault();
//     if (Areaname === '') {
//       Notify('error', 'Please enter Area Name', 'error');
//       return;
//     } else {
//       setloading(true);
//       setaddLoading(true);
//       await dispatch(
//         Add_Area_Action({
//           Areaname,
//           Region,
//         }),
//       );
//       setloading(false);
//       setaddLoading(false);
//     }
//   };

//   const res_Add = useSelector((state) => state.AllArea.Area);

//   useEffect(() => {
//     if (loading === false) {
//       if (res_Add && res_Add.status === 201) {
//         Notify('success', 'Added successfully', 'success');
//       } else {
//         Notify('error', 'Failed to add', 'error');
//         setTimeout(() => {
//           window.location.reload();
//         }, 1500);
//         return;
//       }
//     }
//   }, [loading]);

//   // =========================================

//   // تحديد المسار المناسب بناءً على الدور
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeads'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/LeadsForMarketer'
//         : '/'; // fallback
//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           {/* <div className='mx-4 d-flex'>
//             <div className='mx-3'>Areas</div>
//             <a style={{textDecoration:'none'}} href='/Areas' className='goback'>{"<<"} Go To Areas </a>
//         </div> */}

//           <div>
//             <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//               <span style={{ fontWeight: 'bold' }}>Home</span>
//             </Link>

//             <KeyboardDoubleArrowRightIcon />

//             <Link to={`/Areas`} style={{ textDecoration: 'none', color: '#666' }}>
//               <span style={{ fontWeight: 'bold', color: '#666' }}>Area</span>
//             </Link>

//             <KeyboardDoubleArrowRightIcon />

//             <span style={{ color: '#666' }}>Add Area</span>
//           </div>

//           <div
//             style={{
//               background: mode === 'dark' ? '#333' : '#fff',
//               borderRadius: '15px',
//               padding: '25px',
//             }}
//           >
//             {/* inputes of add Area */}
//             <div>
//               <div>
//                 <label for="Name">Area Name</label>
//                 <input
//                   style={{ background: 'transparent', color: mode === 'dark' ? '#fff' : '#333' }}
//                   onChange={Areanamechange}
//                   value={Areaname}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="Name"
//                   placeholder="Area Name.."
//                 />
//               </div>
//             </div>

//             {/* المنطقه */}
//             <Box sx={{ minWidth: 120 }}>
//               <FormControl fullWidth>
//                 <InputLabel id="demo-simple-select-label">Region</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value={Region}
//                   label="Region"
//                   onChange={handleChange}
//                 >
//                   {res_get_AllRegions_array
//                     ? res_get_AllRegions_array.map((item, index) => {
//                         return (
//                           <MenuItem key={index} value={item._id}>
//                             {item.name}
//                           </MenuItem>
//                         );
//                       })
//                     : null}
//                 </Select>
//               </FormControl>
//             </Box>

//             {/* <div onClick={onsubmitadd}  style={{textAlign:'center',background:'#0F7687'}} className='addnewclient'   type="submit" ><AddIcon/> Add Area</div> */}

//             <Row
//               className="d-flex justify-content-center"
//               style={{ width: '100%', marginTop: '10px', textAlign: 'center' }}
//             >
//               <div
//                 onClick={!addLoading ? onsubmitadd : null}
//                 className="addnewclient"
//                 style={{
//                   background: '#102dff',
//                   pointerEvents: addLoading ? 'none' : 'auto',
//                   opacity: addLoading ? 0.6 : 1,
//                   cursor: addLoading ? 'not-allowed' : 'pointer',
//                   width: '50%',
//                 }}
//                 type="submit"
//               >
//                 {addLoading ? (
//                   <CircularProgress size={20} style={{ color: 'white' }} />
//                 ) : (
//                   <>
//                     <AddIcon /> Add Area
//                   </>
//                 )}
//               </div>
//             </Row>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };


















import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress, FormControl, MenuItem, Select } from '@mui/material';
import { GetAllRegionsData } from '../../Redux/Actions/Regions_Action';
import { Add_Area_Action } from '../../Redux/Actions/AreaActions';
import { Notify } from '../../Utility/Notify';
import AddIcon from '@mui/icons-material/Add';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const AddArea = () => {
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sidebarWidth = useSidebarWidth();

  const [userlogin,  setUserlogin]  = useState(null);
  const [Areaname,   setAreaname]   = useState('');
  const [Region,     setRegion]     = useState('');
  const [loading,    setLoading]    = useState(true);
  const [addLoading, setAddLoading] = useState(false);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  /* fetch regions */
  useEffect(() => {
    dispatch(GetAllRegionsData());
  }, [dispatch]);

  const res_All_Regions = useSelector((state) => state.AllRegions.Region);
  const regionsArray    = Array.isArray(res_All_Regions?.data) ? res_All_Regions.data : [];

  const homeRoute =
    userlogin?.data?.role === 'Admin'    ? '/Regionsandareas'
  : userlogin?.data?.role === 'Marketer' ? '/Regionsandareas'
  : '/';

  const onsubmitadd = async (e) => {
    e.preventDefault();
    if (!Areaname.trim()) return Notify('error', 'Please enter Area Name', 'error');
    setLoading(true);
    setAddLoading(true);
    await dispatch(Add_Area_Action({ Areaname: Areaname.trim(), Region }));
    setLoading(false);
    setAddLoading(false);
  };

  const res_Add = useSelector((state) => state.AllArea.Area);
  useEffect(() => {
    if (loading === false) {
      if (res_Add?.status === 201) {
        Notify('success', 'Added successfully', 'success');
        setAreaname('');
        setRegion('');
      } else {
        Notify('error', 'Failed to add', 'error');
        setTimeout(() => window.location.reload(), 1500);
      }
      setLoading(true);
    }
  }, [loading]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor     = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };

  const selectSx = {
    borderRadius: '10px',
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    height: '48px',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '14px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isDark ? '#2d3248' : '#e2e8f0',
      borderWidth: '1.5px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2563eb' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2563eb',
      boxShadow: '0 0 0 3px rgba(37,99,235,0.12)',
    },
    '& .MuiSelect-select': {
      padding: '13px 16px',
      color: isDark ? '#f1f5f9' : '#0f172a',
    },
    '& .MuiSvgIcon-root': { color: isDark ? '#6b7280' : '#94a3b8' },
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to={homeRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Regions & Areas
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <Link to="/Areas" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Areas
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Add New Area</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px', fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px', letterSpacing: '-0.4px',
            }}>
              Add New Area
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Add a new area and link it to its region in the CRM database
            </p>
          </div>

          {/* Grid — 2 columns */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '8px' }}>

            {/* Area Name */}
            <div>
              <label style={labelStyle}>Area Name *</label>
              <input
                style={inputStyle}
                value={Areaname}
                onChange={(e) => setAreaname(e.target.value)}
                type="text"
                placeholder="e.g. Downtown, Marina"
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={(e) => { if (e.key === 'Enter') onsubmitadd(e); }}
                autoFocus
              />
            </div>

            {/* Region Select */}
            <div>
              <label style={labelStyle}>Region</label>
              <FormControl fullWidth>
                <Select
                  value={Region}
                  onChange={(e) => setRegion(e.target.value)}
                  displayEmpty
                  sx={selectSx}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: isDark ? '#4b5563' : '#94a3b8', fontSize: '14px' }}>
                      Select a region
                    </span>
                  </MenuItem>
                  {regionsArray.map((item) => (
                    <MenuItem
                      key={item._id}
                      value={item._id}
                      sx={{ fontSize: '14px', fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full area name and select the region it belongs to
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!addLoading ? onsubmitadd : null}
              disabled={addLoading}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: addLoading ? 'not-allowed' : 'pointer',
                opacity: addLoading ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!addLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {addLoading
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Adding…</span></>
                : <><AddIcon sx={{ fontSize: 17 }} /><span>Add Area</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate(homeRoute)}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};